"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objekt_rettungsdienst = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.objekt_rettungsdienst = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEySURBVFhH7ZcxE8EwGIbLZDQa2YxGo9FfMPETjFaTEb/AmVhNRkajzchoY7TxvtHeaSTXRNKr3vW5ey4SWl+/5IsICrKmFLY2tGEfNkUvzhVu4Fr0UqADnwYOYSqsoOoLZU/QiHLYmlIL2wvk9MnuIamEbSK2AXiHUctUIRcaleHiq8M7nHNAIun9IzxALlYlTDHnTzWvvrxB1cMJplB1kW93UCBPAd9gqTFFPQ54hg/YglzEDQ7IMABGeBY9/3zdP/MqcA3AOWO5z4AzuQsgmvNIlizh7vc5brwmMs+AbiPSbRQDyKeN0O397M/eL2Mk3d+6rJw/X1SBawBLOIaq3/6fsJ1TW/5vDchluIVd+IA8OvmGZwEe+bRlOIJMUdouoJYJ5LlNdaEP+d+CWSgAQfACURuz3XKRLSEAAAAASUVORK5CYII=",
    iconSize: [32, 32],
});
